import { render } from "./ValueSelector.vue?vue&type=template&id=67047b08&scoped=true"
import script from "./ValueSelector.vue?vue&type=script&lang=js"
export * from "./ValueSelector.vue?vue&type=script&lang=js"

import "./ValueSelector.vue?vue&type=style&index=0&id=67047b08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67047b08"]])

export default __exports__